import React, {useRef} from 'react';
import {useParams} from 'react-router-dom';
import CardsHeader from 'layouts/Headers/CardsHeader.js';


import {PaymentContextProvider} from '../context';

import {Container,} from "reactstrap";

import EditInvoicePaymentContent from './EditInvoicePaymentContent';

export default function EditPayment() {
  const { id, scheduleId } = useParams();

  return (
    <PaymentContextProvider id={id} paymentScheduleId={scheduleId}>
      <CardsHeader name="Deal" parentName="Payment management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <EditInvoicePaymentContent/>
      </Container>
    </PaymentContextProvider>
  )
}